import { render, staticRenderFns } from "./ViewResellerServiceComponent.vue?vue&type=template&id=59294ad4"
import script from "./ViewResellerServiceComponent.vue?vue&type=script&lang=js"
export * from "./ViewResellerServiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports